var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPoster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 169,
    viewBox: "0 0 114 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109 0H5C2.23858 0 0 2.23858 0 5V164C0 166.761 2.23858 169 5 169H109C111.761 169 114 166.761 114 164V5C114 2.23858 111.761 0 109 0Z",
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2534 90.4927L74.5834 93.4887C75.9754 94.0567 77.4994 93.0347 77.4994 91.5307V78.2527C77.4994 76.7487 75.9754 75.7247 74.5834 76.2927L67.2534 79.2887",
    stroke: "white",
    strokeWidth: 1.68616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.608 98.7817H60.146C64.514 98.7817 67.254 95.9357 67.254 91.9057V77.8757C67.254 73.8457 64.526 70.9997 60.146 70.9997H47.608C43.226 70.9997 40.5 73.8457 40.5 77.8757V91.9057C40.5 95.9357 43.226 98.7817 47.608 98.7817Z",
    stroke: "white",
    strokeWidth: 1.68616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPoster);
export default __webpack_public_path__ + "static/media/no-poster.62b54c52e8b8c90dc103f58dbc9af17d.svg";
export { ForwardRef as ReactComponent };